<template>
    <span class="filter-tag badge badge-secondary">
        <span v-if="filter.column == 'perPage'">{{ translations.perPage ?? translate('app.datagrid.per-page') }}:</span>
        <span v-else-if="filter.column == 'page'">{{ translations.page ?? translate('app.datagrid.page') }}:</span>
        <span v-else-if="filter.column == 'include_variants'">{{ translations.variants ?? translate('app.datagrid.include-variants') }}:</span>
        <span v-else>{{ filter.label }}:</span>

        <span class="wrapper" v-if="filter.prettyValue">
            {{ filter.prettyValue }}
            <span
                class="icon cross-icon"
                v-on:click="removeFilter(filter)"
            ></span>
        </span>

        <span class="wrapper" v-else>
            <span v-if="filter.column == 'include_variants'">
                {{
                    filter.val == 1
                        ? translations.yes ?? translate('app.datagrid.yes')
                        : translations.no ?? translate('app.datagrid.no')
                }} 
            </span>

            <span v-else-if="filter.type == 'boolean'">
                {{
                    filter.val == 1
                        ? translations.active
                        : translations.inactive
                }} 
            </span>

            <span v-else>
                {{ decodeURIComponent(filter.val) }}
            </span>

            <span
                class="icon cross-icon"
                v-on:click="removeFilter(filter)"
            ></span>
        </span>
    </span>
</template>

<script>
export default {
    props: ['filter', 'translations'],

    data() {
        return {};
    },

    methods: {
        removeFilter() {
            this.$emit('onRemoveFilter');
        }
    }
};
</script>
